import React from "react";
import { Col, Container, Row } from "react-bootstrap";
import AddDataSourceCardComponent from "../components/AddDataSourceCardComponent";
import {
  faBullseye,
  faDatabase,
  faFileCsv,
  faFileImport,
  faHandPointUp,
  faPlug,
  faUsersViewfinder,
} from "@fortawesome/free-solid-svg-icons";
import DataSourceCardContainer from "../components/DataSourceCardContainer";
import ActionCardComponent from "../components/ActionCardComponent";
import detectionLogo from "../image/detection.png";
import target_marketing from "../image/target_marketing.png";
import accounting from "../image/accounting_2.png";
import analytics from "../image/analytics.png";
import audience from "../image/audience.png";
import benchmarking from "../image/benchmarking.png";
import cross_selling from "../image/cross_selling.png";
import liquidity from "../image/liquidity.png";
import key_performance_indicator from "../image/key_performance_indicator.png";
import churn_prediction from "../image/churn_prediction.png";
import ActionCardContainer from "../components/ActionCardContainer";
import { Colors } from "../utils/style";
import { useTranslation } from 'react-i18next';



function Action() {

  const {t} = useTranslation('action');

  const actions = [
    {
      title: t("ActionsList.0.title"),
      description: t("ActionsList.0.description"),
    },
    {
      title: t("ActionsList.0.title"),
      description: t("ActionsList.1.description"),
    },
    {
      title: t("ActionsList.0.title"),
      description: t("ActionsList.2.description"),
    },
    {
      title: t("ActionsList.0.title"),
      description: t("ActionsList.3.description"),
    },
    {
      title: t("ActionsList.0.title"),
      description: t("ActionsList.4.description"),
    },
    {
      title: t("ActionsList.0.title"),
      description: t("ActionsList.5.description"),
    },
  ];




  return (
    <Container className="mt-4 mb-4">
    <div className="mb-5 mt-5">
      <h2 style={{ color: Colors.DARK_BLUE }}>
        {t("Actions")}
      </h2>
    </div>
    <Container style={{ marginBottom: "0.5rem", marginTop: "0.5rem" }}>
      <Row md={2} xs={1} lg={3} sm={2}>
        {actions?.map((action, index) => (
          <Col style={{ padding: "0.5rem" }} key={index}>
            <ActionCardComponent
              title={action.title}
              description={action.description}
            />
          </Col>
        ))}
      </Row>
    </Container>

    <div style={{ display: "flex", flexDirection: "column", gap: "1rem" }}>
      <ActionCardContainer
        title={t("Action")}
        icon={faPlug}
        description={t("Instructions1")}
      />
      <ActionCardContainer
        title={t("Details")}
        icon={faHandPointUp}
        items={[
          t("Instructions1"),
          t("Instructions2"),
          t("Instructions3"),
        ]}
      />
      <ActionCardContainer
        title={t("Targets")}
        icon={faUsersViewfinder}
        items={[
          t("Targets1"),
          t("Targets2"),
          t("Targets3"),
        ]}
      />
    </div>
  </Container>
  );
}

export default Action;
